const state = {
	atrasados: [],
	abertos: [],
	pagos: [],
	isLoading: false,
}

export default state;
